export default __webpack_public_path__ + "static/media/disconnected.ae65a764.png";